import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import GAEventTracking from '@components/tracking/GAEventTracking';

import FontSettings from './FontSettings';
import ThemeSettings from './ThemeSettings';
import VersionBuild from './VersionBuild';

const SettingsModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const gaEventTracker = GAEventTracking('Settings');

  const showModal = e => {
    e.preventDefault();
    e.currentTarget.blur();
    setIsOpen(true);
    gaEventTracker('Open Settings', 'Open settings modal');
  };

  const hideModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="tooltip-settings-button" style={{ margin: 0 }}>Settings</Tooltip>}
      >
        <a
          href="#"
          className="header-icon"
          onClick={showModal}
        >
          <i className="fal fa-cog" />
        </a>
      </OverlayTrigger>
      <Modal
        show={isOpen}
        onHide={hideModal}
        dialogClassName="modal-dialog-right"
        size="sm"
      >
        <Modal.Header className="dropdown-header bg-trans-gradient d-flex justify-content-center align-items-center w-100">
          <h4 className="m-0 text-center color-white">
            Layout Settings
            <small className="mb-0 opacity-80">User Interface Settings</small>
          </h4>
          <button
            type="button"
            className="close text-white position-absolute pos-top pos-top pos-right p-2 m-1 mr-2"
            aria-label="Close"
            onClick={hideModal}
          >
            <span aria-hidden="true">
              <i className="fal fa-times" />
            </span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <FontSettings />
          <hr className="mb-4 mt-4" />
          <ThemeSettings />
        </Modal.Body>
        <Modal.Footer>
          <VersionBuild />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SettingsModal;
